import schemaParser from './schemaParser.js';
export { schemaParser };
//# sourceMappingURL=index.js.map